module.exports = __webpack_public_path__ + "static/media/icon8.8ca2b183.svg";